// Pending scenario selection for SessionPage routing. No visual impact.
let pendingScenarioId = null;

export function setPendingScenario(id) {
  pendingScenarioId = id;
}

export function consumePendingScenario() {
  const id = pendingScenarioId;
  pendingScenarioId = null;
  return id;
}

export function peekPendingScenario() {
  return pendingScenarioId;
}
